(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bp-combo-offer-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('combo-offer-builder')) {
    class ComboOfferBuilder extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;

        this.comboTriggers = Array.from(
          this.querySelectorAll('[data-combo-trigger]')
        );

        this.sources = new Map(
          Array.from(
            this.querySelectorAll('[data-combo-source]')
          ).map((source) => [
            source.dataset.comboSource,
            source
          ])
        );

        this.imageOne = this.querySelector('[data-preview-image="one"]');
        this.imageTwo = this.querySelector('[data-preview-image="two"]');

        this.titleOne = this.querySelector('[data-product-title="one"]');
        this.titleTwo = this.querySelector('[data-product-title="two"]');

        this.summaryProductOne =
          this.querySelector('[data-summary-product-one]');

        this.summaryProductTwo =
          this.querySelector('[data-summary-product-two]');

        this.activeComboTitle =
          this.querySelector('[data-active-combo-title]');

        this.summaryCombo =
          this.querySelector('[data-summary-combo]');

        this.originalPrice =
          this.querySelector('[data-original-price]');

        this.discountPrice =
          this.querySelector('[data-discount-price]');

        this.finalPrice =
          this.querySelector('[data-final-price]');

        this.discountLabel =
          this.querySelector('[data-discount-label]');

        this.savingBadge =
          this.querySelector('[data-saving-badge]');

        this.sizePrice55 =
          this.querySelector('[data-size-price="55"]');

        this.sizePrice100 =
          this.querySelector('[data-size-price="100"]');

        this.ctaPrice =
          this.querySelector('[data-cta-price]');

        this.mobilePrice =
          this.querySelector('[data-mobile-price]');

        this.addButtons = Array.from(
          this.querySelectorAll(
            '[data-add-combo], [data-mobile-add-combo]'
          )
        );

        this.addButtonTexts = Array.from(
          this.querySelectorAll(
            '[data-add-button-text], [data-mobile-add-text]'
          )
        );

        this.status =
          this.querySelector('[data-status]');

        this.activeComboId =
          this.comboTriggers[0]?.dataset.comboTrigger || '';

        this.size = '55';

        this.comboTriggers.forEach((trigger) => {
          trigger.addEventListener('click', () => {
            this.setCombo(
              trigger.dataset.comboTrigger
            );
          });
        });

        this.querySelectorAll(
          'input[name^="bp-combo-size-"]'
        ).forEach((input) => {
          input.addEventListener('change', () => {
            if (!input.checked) return;

            this.size = input.value;
            this.render();
          });
        });

        this.addButtons.forEach((button) => {
          button.addEventListener(
            'click',
            () => this.addCombo()
          );
        });

        this.setCombo(this.activeComboId);
      }

      get source() {
        return this.sources.get(this.activeComboId);
      }

      get ready() {
        const source = this.source;

        if (!source) return false;

        return source.getAttribute(
          `data-ready-${this.size}`
        ) === 'true';
      }

      get finalPriceText() {
        return this.source?.getAttribute(
          `data-final-${this.size}`
        ) || '—';
      }

      setCombo(comboId) {
        if (!this.sources.has(comboId)) return;

        this.activeComboId = comboId;

        this.comboTriggers.forEach((trigger) => {
          const active =
            trigger.dataset.comboTrigger === comboId;

          trigger.classList.toggle(
            'is-active',
            active
          );

          trigger.setAttribute(
            'aria-selected',
            active ? 'true' : 'false'
          );
        });

        const source = this.source;

        const ready55 =
          source?.getAttribute('data-ready-55') === 'true';

        const ready100 =
          source?.getAttribute('data-ready-100') === 'true';

        if (
          (this.size === '55' && !ready55) ||
          (this.size === '100' && !ready100)
        ) {
          if (ready55) {
            this.size = '55';
          } else if (ready100) {
            this.size = '100';
          }
        }

        const sizeInput =
          this.querySelector(
            `input[name^="bp-combo-size-"][value="${this.size}"]`
          );

        if (sizeInput) {
          sizeInput.checked = true;
        }

        this.render();
      }

      render() {
        const source = this.source;
        if (!source) return;

        const oneTitle =
          source.dataset.productOneTitle || '';

        const twoTitle =
          source.dataset.productTwoTitle || '';

        const oneImage =
          source.dataset.productOneImage || '';

        const twoImage =
          source.dataset.productTwoImage || '';

        if (this.imageOne) {
          if (oneImage) {
            this.imageOne.src = oneImage;
          } else {
            this.imageOne.removeAttribute('src');
          }

          this.imageOne.alt =
            source.dataset.productOneAlt || oneTitle;
        }

        if (this.imageTwo) {
          if (twoImage) {
            this.imageTwo.src = twoImage;
          } else {
            this.imageTwo.removeAttribute('src');
          }

          this.imageTwo.alt =
            source.dataset.productTwoAlt || twoTitle;
        }

        if (this.titleOne) {
          this.titleOne.textContent = oneTitle;
        }

        if (this.titleTwo) {
          this.titleTwo.textContent = twoTitle;
        }

        if (this.summaryProductOne) {
          this.summaryProductOne.textContent = oneTitle;
        }

        if (this.summaryProductTwo) {
          this.summaryProductTwo.textContent = twoTitle;
        }

        if (this.activeComboTitle) {
          this.activeComboTitle.textContent =
            source.dataset.comboTitle || '';
        }

        if (this.summaryCombo) {
          this.summaryCombo.textContent =
            `${source.dataset.comboTitle || ''} · ${this.size}ML PAIR`;
        }

        const discount =
          this.size === '100' ? '12' : '5';

        if (this.discountLabel) {
          this.discountLabel.textContent =
            `You save ${discount}%`;
        }

        if (this.savingBadge) {
          this.savingBadge.textContent =
            `SAVE ${discount}%`;
        }

        const ready55 =
          source.getAttribute('data-ready-55') === 'true';

        const ready100 =
          source.getAttribute('data-ready-100') === 'true';

        this.updateSizeAvailability('55', ready55);
        this.updateSizeAvailability('100', ready100);

        if (this.sizePrice55) {
          this.sizePrice55.textContent =
            ready55
              ? source.getAttribute('data-final-55') || '—'
              : 'Unavailable';
        }

        if (this.sizePrice100) {
          this.sizePrice100.textContent =
            ready100
              ? source.getAttribute('data-final-100') || '—'
              : 'Unavailable';
        }

        if (!this.ready) {
          if (this.originalPrice) {
            this.originalPrice.textContent = '—';
          }

          if (this.discountPrice) {
            this.discountPrice.textContent = '—';
          }

          if (this.finalPrice) {
            this.finalPrice.textContent = '—';
          }

          if (this.ctaPrice) {
            this.ctaPrice.textContent = '—';
          }

          if (this.mobilePrice) {
            this.mobilePrice.textContent = '—';
          }

          this.setButtonsDisabled(true);

          if (this.status) {
            this.status.textContent =
              'This size is not configured for this pairing.';
          }

          return;
        }

        const original =
          source.getAttribute(
            `data-original-${this.size}`
          ) || '—';

        const saving =
          source.getAttribute(
            `data-saving-${this.size}`
          ) || '—';

        const final =
          source.getAttribute(
            `data-final-${this.size}`
          ) || '—';

        if (this.originalPrice) {
          this.originalPrice.textContent = original;
        }

        if (this.discountPrice) {
          this.discountPrice.textContent = saving;
        }

        if (this.finalPrice) {
          this.finalPrice.textContent = final;
        }

        if (this.ctaPrice) {
          this.ctaPrice.textContent = final;
        }

        if (this.mobilePrice) {
          this.mobilePrice.textContent = final;
        }

        this.addButtonTexts.forEach((text) => {
          text.textContent =
            `${this.dataset.addLabel} · ${this.size}ML`;
        });

        this.setButtonsDisabled(false);

        if (this.status) {
          this.status.textContent = '';
        }
      }

      updateSizeAvailability(size, available) {
        const input = this.querySelector(
          `input[name^="bp-combo-size-"][value="${size}"]`
        );

        if (!input) return;

        input.disabled = !available;

        const label = input.closest('label');

        label?.classList.toggle(
          'is-disabled',
          !available
        );
      }

      setButtonsDisabled(disabled) {
        this.addButtons.forEach((button) => {
          button.disabled = disabled;
        });
      }

      setLoading(loading) {
        this.addButtons.forEach((button) => {
          button.classList.toggle(
            'loading',
            loading
          );

          button.disabled =
            loading ? true : !this.ready;
        });
      }

      setButtonText(text) {
        this.addButtonTexts.forEach((node) => {
          node.textContent = text;
        });
      }

      async addCombo() {
        const source = this.source;

        if (!source || !this.ready) return;

        const variantOneId =
          source.getAttribute(`data-v1-${this.size}`);

        const variantTwoId =
          source.getAttribute(`data-v2-${this.size}`);

        if (
          !variantOneId ||
          !variantTwoId ||
          variantOneId === variantTwoId
        ) {
          if (this.status) {
            this.status.textContent =
              'This combo is not configured correctly.';
          }

          return;
        }

        this.setLoading(true);
        this.setButtonText(
          this.dataset.addingLabel
        );

        if (this.status) {
          this.status.textContent = '';
        }

        try {
          const root =
            window.Shopify?.routes?.root || '/';

          const cartComponent =
            document.querySelector(
              'cart-component'
            );

          const sectionsToRender = [
            'cart-badge',
            'cart-drawer'
          ];

          const response = await fetch(
            `${root}cart/add.js`,
            {
              method: 'POST',

              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },

              body: JSON.stringify({
                items: [
                  {
                    id: Number(variantOneId),
                    quantity: 1,
                    properties: {
                      'Combo':
                        source.dataset.comboTitle ||
                        'B Perfume Combo',
                      'Combo Size':
                        `${this.size}ml`
                    }
                  },
                  {
                    id: Number(variantTwoId),
                    quantity: 1,
                    properties: {
                      'Combo':
                        source.dataset.comboTitle ||
                        'B Perfume Combo',
                      'Combo Size':
                        `${this.size}ml`
                    }
                  }
                ],

                sections: sectionsToRender,
                sections_url:
                  window.location.pathname
              })
            }
          );

          const data = await response.json();

          if (!response.ok) {
            throw data;
          }

          window.dispatchEvent(
            new CustomEvent(
              'cart:added',
              { detail: data }
            )
          );

          if (
            cartComponent?.renderCart &&
            data.sections
          ) {
            cartComponent.renderCart(
              data.sections
            );
          }

          document
            .querySelector('#cart-drawer')
            ?.showModal();

          this.setButtonText(
            this.dataset.addedLabel
          );

          if (this.status) {
            this.status.textContent =
              'Pair added to cart.';
          }

          window.setTimeout(() => {
            this.setButtonText(
              `${this.dataset.addLabel} · ${this.size}ML`
            );
          }, 1600);

        } catch (error) {
          if (this.status) {
            this.status.textContent =
              error?.description ||
              error?.message ||
              this.dataset.errorLabel;
          }

          this.setButtonText(
            `${this.dataset.addLabel} · ${this.size}ML`
          );

        } finally {
          this.setLoading(false);
        }
      }
    }

    customElements.define(
      'combo-offer-builder',
      ComboOfferBuilder
    );
  }

  } catch(e) { console.error(e); }
})();
})();
